import React, { Component } from "react";  
import ImgLogo from "../../assets/images/budapester-logo-1x.png"
class Logo extends Component {
  render() {
    return ( 
      <> 
        <img src={ImgLogo} alt="MyBudapester" className="img-fluid" />
      </>
    );
  }
}
export default Logo;